


























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import NoteCategoryDto from '@/models/NoteCategories/NoteCategoryDto'
import NoteCategoryEdit from '@/components/NoteCategories/NoteCategoryEdit.vue';
import NoteCategoryCreate from '@/components/NoteCategories/NoteCategoryCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'NoteCategories',
  components: { NoteCategoryEdit, NoteCategoryCreate }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentNoteCategory(null);
    }

    async updateCurrentNoteCategory(noteCategory: NoteCategoryDto) {
        AgencySettingsModule.updateCurrentNoteCategory(noteCategory);
    }

    get currentNoteCategory() {
        return AgencySettingsModule.currentNoteCategory;
    }

    get loading() {
        return AgencySettingsModule.loadingNoteCategories;
    }

    get noteCategories() {
        return AgencySettingsModule.noteCategories;
    }

    async deleteNoteCategory(noteCategory: NoteCategoryDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the note category ' + noteCategory.name + '?', options);
  }
}
